import { useEffect } from "react";
import Sidebar from "../../components/layout/Sidebar";
import Header from "../../common/Header";
const AppContent = ({children}) => {

    useEffect(() => {
     if(!localStorage.getItem('auth_token')) {
        window.location.href = '/'
     }
    },[])
    return (
        <div className="flex min-h-screen bg-gray-50 overflow-hidden"> 
            <Sidebar /> 
        
            <main className="flex-grow overflow-hidden h-screen ">
                <Header />
                {children}
            </main>
        </div>
    )
}
export default AppContent;